export default {
  admin: 'Msimamizi',
  password: {
    enterNewPassword: 'Weka nenosiri jipya',
    reenterNewPassword: 'Weka tena nenosiri jipya',
    updatePassword: 'Sasisha nenosiri',
    setPassword: 'Weka nenosiri',
    min8CharacterMessage: 'Nenosiri lazima liwe na angalau herufi 8',
    passwordSentMessage: 'Nenosiri limepelekwa kwa {userName} kupitia barua pepe.',
    generateNewPassword: 'Tengeneza nenosiri jipya',
    assignPasswordMessage:
      'Weka nenosiri kwa mtumiaji. Mtumiaji atahitajika kubadilisha nenosiri hili wakati wa kuingia tena.',
    generateSecurePassword: 'Tengeneza nenosiri salama',
    newPassword: 'Nenosiri jipya',
    confirmNewPassword: 'Thibitisha nenosiri jipya',
    passwordHistory: 'Historia ya manenosiri',
    passwordUpdatedLog: 'Nenosiri limesasishwa na {userName} tarehe {date}.',
    forgotPasswordLog: 'Ombi la nenosiri lililosahaulika lilipelekwa na {userName} tarehe {date}.',
  },
};
